import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ROUTES } from '../constants';

const StandaloneBackButton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(window.matchMedia('(display-mode: standalone)').matches);
  }, []);

  if (!show) return null;

  return (
    <Box
      component={Link}
      to={ROUTES.mediaLists}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        mb: 1.5,
        color: 'text.secondary',
        textDecoration: 'none',
        fontSize: '0.85rem',
        '&:hover': { color: 'primary.main' },
      }}
    >
      <ArrowBackIcon sx={{ fontSize: 16 }} />
      Media Lists
    </Box>
  );
};

export default StandaloneBackButton;
